import { AutoComplete } from 'antd';
import { useState } from 'react';
import { search } from 'src/api/user'
interface UserNameAutoCompleteProps {
  appendSearchForm: (values: any) => void;
}

export const UserNameAutoComplete = ({ appendSearchForm }: UserNameAutoCompleteProps) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);
  const [searchText, setSearchText] = useState('');

  const handleSearch = async (value: string) => {
    setSearchText(value);
    if (value.trim()) {
      const result = await search({ username: value });
      if (result?.data?.length) {
        
        const suggestions = result.data.map((user: any) => ({
          label: user.userName,
          value: user.userName,
        }));
       
        setOptions(suggestions);
      } else {
       
        setOptions([]);
      }
    } else {
      setOptions([]);
    }
  };

  const handleChange = (value: string) => {
    setSearchText(value);
    appendSearchForm({ userName: value });
  };

  return (
   
      <AutoComplete
        options={options}
        onSearch={handleSearch}
        onChange={handleChange}
        value={searchText}
        allowClear
        placeholder="User Name"
        className="search-input"
        style={{ width: '100%' }}
      />
   
  );
};
